import { render, staticRenderFns } from "./ScriptManage.vue?vue&type=template&id=9b49d420&scoped=true"
import script from "./ScriptManage.vue?vue&type=script&lang=js"
export * from "./ScriptManage.vue?vue&type=script&lang=js"
import style0 from "./ScriptManage.vue?vue&type=style&index=0&id=9b49d420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b49d420",
  null
  
)

export default component.exports